$(function () {
  // showMoreContent();
  displayMoreInfo();
  initSlider();
  scrollToActiveItem();
  //closeButton();
  //addShadow();


  /* ---------------------------------- BUS STOP ACCORDION ---------------------------------- */
  $("[data-content-collapsable]").on('click', function () {
    accordionContent($(this));
  }); 

  $("[data-content-collapsable]").on("keydown", function (e) {
    if ( e.which === 13 ) {
      e.preventDefault();
      accordionContent($(this));
    }
  });

  if ($(window).width() < 768) {
    $("[data-mobile-close]").on('click', function () {
      accordionContent($(this));
    });
  }
 

   $("[data-mobile-close]").on("keydown", function (e) {
    if ( e.which === 13 ) {
      e.preventDefault();
      accordionContent($(this));
    }
  }); 

  /* ---------------------------------- CHANGE CONTENT - TAB ---------------------------------- */

  $("[data-content-id]").on('click', function () {
    changeTabContent($(this));

    // scrollToObj($("[data-content-id-wrapper]"), 60, 800);
  });

  $("[data-content-id]").on("keydown", function (e) {
    if (e.keyCode === 13) {
      changeTabContent($(this));

      // scrollToObj($("[data-content-id-wrapper]"), 60, 800);
    }
  });

  $("[data-updates-id]").on('click', function () {
    $('[data-timetable-content]').addClass("loading");
  });

  $("[data-updates-id]").on("keydown", function (e) {
    if (e.keyCode === 13) {
      $('[data-timetable-content]').addClass("loading");
    }
  });
});

/* ---------------------------------- UPDATES TAB LIST SLIDER --------------------------- */
function initSlider() {
  var tabsItems = $(".updatesTabList li");
  var selectedItem = tabsItems.filter(".activeLi");
  
  Splide.defaults = {
    i18n: {
      prev:   'Poprzedni slajd',
      next:   'Następny slajd',
      pageX:  'Strona %s',
    },
  };

  if (selectedItem.length > 0) {
    goToItemIndex = tabsItems.index(selectedItem)
  }

  if ($(".updatesTabList li").length > 2 || $(window).width() < 992 && $(".updatesTabList li").length > 1 ) {
    const tabSlider = new Splide(".updatesSlider", {
      autoWidth: true,
      pagination: false, 
      arrows: true,
      perMove: 1,
      gap: "20px",
    }).mount();
    
    selectedItem.length > 0 && tabSlider.go(goToItemIndex);
  }

  // scrollToObj($("[data-timetable-content]"), 70, 800);

  // COMMUNICATION CHANGES SLIDER
  if ($(".announcedBox li").length > 3 
      || $(window).width() < 992 && $(".announcedBox li").length > 2 
      || $(window).width() < 768 && $(".announcedBox li").length > 1 ) {
    const announceSlider = new Splide(".announcedSlider", {
      autoWidth: true,
      pagination: false,
      arrows: true,
      perMove: 2,
      gap: "20px",
    }).mount();
  }

  if ($(".announcedBox li").length < 4) {
    $('[data-short-list]').addClass('shortList');
  }
}

/* ---------------------------------- BUS STOP ACCORDION ---------------------------------- */
function accordionContent($obj) {
  if ($obj.parent().hasClass("isExpanded")) {
    $obj.parent().removeClass("isExpanded");
    $('[data-more-info]').attr('aria-expanded', 'false');
    $obj.find('[data-change-text]').text("Rozwiń");
    $obj.parent().find("[data-body]").stop().slideUp();
  } else {
    $obj.parent().addClass("isExpanded");
    $('[data-more-info]').attr('aria-expanded', 'true');
    $obj.find('[data-change-text]').text("Zwiń");
    $obj.parent().find("[data-body]").stop().slideDown();
  }
}


/* ---------------------------------- CHANGE CONTENT - TAB ---------------------------------- */
function changeTabContent($obj) {
  $("[data-content-id]").removeClass("active").attr('aria-selected','false');
  $("[data-change-content]").removeClass("active");
  $obj.addClass("active").attr('aria-selected','true');

  var content = $obj.attr("data-content-id");
  $("[data-change-content]").fadeOut(0);
  $("#" + content).fadeIn(500);
}

/* ---------------------------------- SCROLL TO ELEMENT ---------------------------------- */
// function scrollToObj($obj, $offset, $time) {
//   if ($.isNumeric($obj)) {
//     return;
//   }
//   if ($(window).width() > 769) {
//     $("html, body").animate({
//         scrollTop: $obj.offset().top - $offset,
//       }, $time);
//   } else {
//     $("html, body").animate({
//         scrollTop: $obj.offset().top - 50 - $offset,
//       }, $time);
//   }
// }

/* ---------------------------------- SHOW MORE TEXT DESCRIPTION AFTER CLICKED ON BTN ---------------------------------- */
function displayMoreInfo() {
  $("[data-display-info]").on('click', function (e) {
    e.preventDefault();

    const boxWrapper = $(this).closest("[data-info-wrapper]");

    if (boxWrapper.hasClass("expanded")) {
      boxWrapper.stop().slideDown().removeClass("expanded");
      $('[data-more-info]').attr('aria-expanded', 'false');
      boxWrapper.find('[data-change-text]').text("Rozwiń legende");

      boxWrapper.find("[data-li]").each(function (i) {
        if (i >= 1) $(this).stop().slideUp().addClass("hidePhone");
      });
    } else {
      $('[data-more-info]').attr('aria-expanded', 'true');
      boxWrapper.find('[data-change-text]').text("Zwiń legende");
      boxWrapper
        .addClass("expanded")
        .find("[data-li]")
        .stop()
        .slideDown()
        .removeClass("hidePhone");
    }
  });
}

/* ---------------------------------- SHOW MORE CONTENT ON CLICK ---------------------------------- */
// Doczytywanie ilosci elementów w widoku 'bus_station'

// function showMoreContent() {
//   $("[data-more-info]").on('click', function (e) {
//     e.preventDefault();
//     const boxWrapper = $(this).closest("[data-info-wrapper]");

//     boxWrapper.addClass("expanded").find("[data-li]").removeClass("hideItem");
//   });
// }

/* ---------------------------------- ADD SHADOW TO ACCORDION CONTENT LIST ---------------------------------- */
// function addShadow() {
//   const list = [...document.querySelectorAll("[data-info-wrapper] [data-li]")];
//   const active = document.querySelector("[data-info-wrapper] [data-li].active");
//   const activeIndex = list.indexOf(active);

//   const listLength = list.length - 5;

//   console.log('listLength', listLength);

//   // if (activeIndex > 8) {
//   //   $("[data-info-wrapper]").addClass("expanded");
//   //   $("[data-info-wrapper] [data-li]").removeClass("hideItem");
//   // }

//   if (activeIndex > 1) {
//     $("[data-info-wrapper]").addClass("topShadow");
//   }

//   if (activeIndex < listLength) {
//     $("[data-info-wrapper]").addClass("bottomShadow");
//   }
// }

/* ---------------------------------- SCROLL TO ACTIVE ELEMENT IN BUS LIST ---------------------------------- */
function scrollToActiveItem() {
  if($('[data-info-wrapper] [data-li]').length > 0 && $('#accordionWithScroll .simplebar-content-wrapper').length > 0) {
    $('#accordionWithScroll .simplebar-content-wrapper').animate({
      scrollTop: $('[data-li].active').offset().top - $('#accordionWithScroll .simplebar-content-wrapper').offset().top - 70
    },'slow');
  };
}

/* ---------------------------------- REMOVE OR ADD TITLE ATTR WITH ROUTE TOOLTIP ---------------------------------- */

$(function() {
  // zaznaczenie input-checkbox za pomoca klawiatury
  $('input:checkbox').keypress(function(e){
    e.preventDefault();
    if((e.keyCode ? e.keyCode : e.which) == 13){
        $(this).trigger('click');
    }
  });

  if (getCookie("showTooltip") === "1") {
    checkBox();
  } else {
    $('.routeTooltip').hasClass("checked");
  }

  $("#tooltip").on("click", function () {
    checkBox();
  });
})

function checkBox() {
  var elAttr = $('li.busTimetableElement');

  if ($('.routeTooltip').hasClass("checked")) {
    $('.routeTooltip').removeClass("checked");
    $('#tooltip').removeAttr("checked");
    elAttr.attr("tooltip-data", elAttr.attr("data-title"));
    elAttr.removeAttr("data-title");
    $('[data-hide-route]').addClass('hide');
    setCookie("showTooltip", 1, 365);

  } else {
    $('.routeTooltip').addClass("checked");
    elAttr.attr("data-title", elAttr.attr("tooltip-data"));
    elAttr.removeAttr("tooltip-data");
    $('#tooltip').attr("checked");
    $('[data-hide-route]').removeClass('hide');
    setCookie("showTooltip", 0, 365);
  }
}


// bannerBox - zamkniecie baneru - cookie ustawione na 24h 
// function closeButton() {
//   if (getCookie("bannerBoxCookie") === "1") {
//     $("[data-banner-content]").hide();
//   } else {
//     $("[data-banner-content]").show();
//   }

//   $("[data-close-banner]").on("click", function () {
//     closeBox();
//   });

//   $("[data-close-banner]").on("keydown", function (e) {
//     if (e.keyCode === 13) {
//       closeBox();
//     } 
//   });
// }

// function closeBox() {
//   $("[data-banner-content]").hide();
//   setCookie("bannerBoxCookie", 1, 1);
// }

// COOKIES
function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$('[data-title]').on("keydown", function(e) {
  if (e.keyCode === 27) {
    $(this).addClass('without-after-element');
  }
});

$('[data-other-lines]').on("keydown", function(e) {
  if (e.keyCode === 27) {
    $(this).addClass('without-after-element');
  }
});



// $(document).ready(function(){
//   $('#boxShareSticky').jsSocials({
//     showCount: false,
//     showLabel: false,
//     shares: [
//       { share: "facebook", label: "Podziel się" },
//       { share: "twitter" },
//       { share: "googleplus" }//,
//       // "comments"
//     ],
//     on: {
//       click: function(e) {
//         if(this.share === "comments") {
//           e.preventDefault();
//           var oPosition = $('.boxComments').position();
//           $("html, body").animate({ scrollTop: oPosition.top }, "slow");
//         }
//       }
//     }
//   });

//   if ( $('.boxSocialSticky').parent().hasClass('articleBodyContent') ) {
//     $(".boxSocialSticky").stick_in_parent()
//       .on("sticky_kit:stick",function(a){
//         $(".boxSocialSticky").css("left",$(".articleBodyContent ").offset().left)
//       })
//       .on("sticky_kit:unstick",function(a){
//         $(".boxSocialSticky").css("left","0")
//       })
//   } else {
//     $(".boxSocialSticky").stick_in_parent()
//       .on("sticky_kit:stick",function(a){
//         $(".boxSocialSticky").css("left",$(".mainContent").offset().left - 43)
//       })
//       .on("sticky_kit:unstick",function(a){
//         $(".boxSocialSticky").css("left","-43px")
//       })
//   }

//   $("a.fancybox").fancybox({
//     'transitionIn'	:	'elastic',
//     'transitionOut'	:	'elastic',
//     'speedIn'		:	1000,
//     'speedOut'		:	400,
//     'overlayShow'	:	false
//   });

//   $('.read-hidden-text').click(function() {
//     if ($(this).hasClass('expanded-text-area')) {
//       $(this).removeClass('expanded-text-area');
//       $('.hidden-area-text').slideUp(500);
//       scrollToPage($('.mainContent').find('.txtLead'), 200, 500);
//     } else {
//       $(this).addClass('expanded-text-area');
//       $('.hidden-area-text').slideDown(500);
//       scrollToPage($('.mainContent').find('.articleBodyContent '), 15, 500);
//     }
//   });


//   dropdownAnimation();
// });

